<template>
    <v-dialog
        v-model="modalDialogoHistorico"
        scrollable
        max-width="700"
      >
        <v-card>
          <v-toolbar
            dark
            height="50"
            color="secondary"
          >
            <v-btn
                icon
                dark
                @click="fecharDialogoHistorico"
            >
              <v-icon small>close</v-icon>
            </v-btn>
            <v-toolbar-title class="body-2">Histórico de Avaliação</v-toolbar-title>
          </v-toolbar>
          <v-progress-linear indeterminate height="3" v-if="isLoadingHistorico"/>

          <template v-else>
            <v-data-table
              :headers="historicoTableHeaders"
              :items="historicoAvaliacao"
              class="elevation-1"
              hide-actions
              :loading="isLoadingHistorico"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.dh_operacao_formatado }}</td>
                <td class="text-xs-center">{{ props.item.ds_operacao }}</td>
                <td class="text-xs-center">{{ props.item.usuarioExpedidor.no_nome }}</td>
                <td class="text-xs-center">{{ props.item.usuarioReceptor ? props.item.usuarioReceptor.no_nome: '-' }}</td>
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name:'HistoricoAvaliacaoDialog',
    props:{
        value:{
            type: Boolean,
            default: false,
        },
        recursoInscricao:{
            type: Number,
            default: 0
        }
    },
    data(){
        return{
            modalDialogoHistorico: false,
            isLoadingHistorico: false,
            historicoTableHeaders: [
                {
                    text: 'Data',
                    align: 'center',
                    sortable: false,
                    class: 'grey lighten-4 text--secondary text-uppercase'
                },
                {
                    text: 'Operação',
                    align: 'center',
                    sortable: false,
                    class: 'grey lighten-4 text--secondary text-uppercase'
                },
                {
                    text: 'Expedidor',
                    align: 'center',
                    sortable: false,
                    class: 'grey lighten-4 text--secondary text-uppercase'
                },
                {
                    text: 'Receptor',
                    align: 'center',
                    sortable: false,
                    class: 'grey lighten-4 text--secondary text-uppercase'
                },
            ],
        }
    },
    filters:{},
    computed: {
        ...mapGetters({
            historicoAvaliacao: 'recurso/historicoAvaliacao'
        }),
    },
    watch: {
        value(alternarModalAtivo){
            this.modalDialogoHistorico = alternarModalAtivo;
        },
        modalDialogoHistorico(alternarModalAtivo){
            this.$emit('input', alternarModalAtivo);
        },
        recursoInscricao(codigoRecurso){
            if(codigoRecurso == 0){
                return;
            }
            this.isLoadingHistorico = true;
            this.obterHistoricoAvaliacao(codigoRecurso);
        },
        historicoAvaliacao(){
            this.isLoadingHistorico = false;
        }
    },
    methods: {
        ...mapActions({
            obterHistoricoAvaliacao: 'recurso/obterHistoricoAvaliacao',
        }),
        fecharDialogoHistorico() {
            this.modalDialogoHistorico = false;
        },
    },
}
</script>